import { getRequest } from '@fo-apis/axios';

const getMileage = () =>
  getRequest({
    url: '/api/v1/skypass/get-mileage',
  });

const skypassMileageApi = {
  getMileage,
};

export default skypassMileageApi;
